// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: "WPCloud",
    appLogoImage: require("@src/assets/images/liscr_logo.png"),
    successStatusImage: require("@src/assets/images/success_status.png"),
    errorStatusImage: require("@src/assets/images/error_status.png")
  },
  navicons: {
    menu1: require("@src/assets/images/reports_menu_left.svg"),
    menu2: require("@src/assets/images/reports_menu_left.svg"),

    graph1: require("@src/assets/images/graph_light.png"),
    graph2: require("@src/assets/images/graph_dark1.png"),

    dashboard1: require("@src/assets/images/nav_icons/dashboard_icon_black.png"),
    dashboard2: require("@src/assets/images/nav_icons/dashboard_icon.png"),

    arrival1: require("@src/assets/images/iconfinder-arrivals.png"),
    arrival2: require("@src/assets/images/iconfinder-arrivals1.png"),

    caseFile1: require("@src/assets/images/iconfinder-caseFiles.png"),
    caseFile2: require("@src/assets/images/iconfinder-caseFiles1.png"),

    preCheck1: require("@src/assets/images/iconfinder-preArrivalChecklist.png"),
    preCheck2: require("@src/assets/images/iconfinder-preArrivalChecklist1.png"),

    fleet1: require("@src/assets/images/iconfinder-fleet.png"),
    fleet2: require("@src/assets/images/iconfinder-fleet1.png"),

    ports1: require("@src/assets/images/iconfinder-ports.png"),
    ports2: require("@src/assets/images/iconfinder-ports1.png"),

    email1: require("@src/assets/images/iconfinder-emailRule.png"),
    email2: require("@src/assets/images/iconfinder-emailRule1.png"),

    dataStatus1: require("@src/assets/images/iconfinder-icon-downloadStatistic.png"),
    dataStatus2: require("@src/assets/images/iconfinder-icon-downloadStatistic1.png"),

    admin1: require("@src/assets/images/iconfinder-administrator.png"),
    admin2: require("@src/assets/images/iconfinder-administrator1.png"),

    inspection1: require("@src/assets/images/iconfinder-inspection.svg"),
    inspection2: require("@src/assets/images/iconfinder-inspection.svg"),

    home1: require("@src/assets/images/home.png"),
    home2: require("@src/assets/images/home1.png"),

    appSettings: require("@src/assets/images/nav_icons/appSettings.png"),
    appSettings1: require("@src/assets/images/nav_icons/appSettings_01.png"),

    bulkCarrier: require("@src/assets/images/nav_icons/bulkCarrier.png"),
    container: require("@src/assets/images/nav_icons/shipping.png"),
    tanker: require("@src/assets/images/nav_icons/tanker.png"),
    cargos_ship: require("@src/assets/images/nav_icons/cargos_ship.png"),

    tokyoMou: require("@src/assets/images/nav_icons/tokyo_MOU.png"),
    parisMou: require("@src/assets/images/nav_icons/paris_MOU.png"),
    usCoastGuard: require("@src/assets/images/nav_icons/uS_Coastguard_MOU.png"),
    amsaMou: require("@src/assets/images/nav_icons/amsaMou.svg"),

    panamaFlag: require("@src/assets/images/nav_icons/panama_Flag.png"),
    liberiaFlag: require("@src/assets/images/nav_icons/liberian_Flag.png"),
    marshallFlag: require("@src/assets/images/nav_icons/marshall_Islands_Flag.png"),

    user: require("@src/assets/images/navicons/user_profile.png")
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "sticky", // static , sticky , floating, hidden
      backgroundColor: "white" // BS color options [primary, success, etc]
    },
    footer: {
      type: "static" // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
    toastPosition: "top-right" // top-left, top-center, top-right, bottom-left, bottom-center, bottom-right
  }
}

export default themeConfig
